/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import {styled} from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Markdown from './Markdown';
//color button styles - starts
import {purple} from '@mui/material/colors';
import Button from '@mui/material/Button';
import goToContact from '../../utils/goToContact';
//color button styles - ends

const sxStyles = {
  markdown: {
    fontSize: '0.875rem',
    lineHeight: 1.43,
    letterSpacing: '0.01071em',
    padding: '24px 0',
    // Markdown bodies contain raw URLs used as their own link text, and a URL
    // has no spaces to break at. One of them measured 449px inside a 360px
    // phone viewport and made the whole privacy post scroll sideways. `anywhere`
    // rather than `break-word` because break-word will not split a single
    // unbroken token that is already on its own line.
    overflowWrap: 'anywhere',
  },
};

function routeToContactUs() {
  // Navigate, don't reach into the header and synthesise a click.
  //
  // This used to querySelector a path ending `ul > li:nth-child(11) > a` and
  // call .click() on it. That depended on Contact Us being the eleventh item in
  // the navigation, so any reordering silently sent the reader somewhere else,
  // and any removal made querySelector return null and threw
  // "Cannot read properties of null (reading 'click')" on the button press.
  // Grouping the nav into dropdowns moved that index today.
  goToContact();
}

const ColorButton = styled(Button)(({theme}) => ({
  color: theme.palette.getContrastText(purple[500]),
  background: 'linear-gradient(to right, #00e89d, #0078ff)',
  '&:hover': {
    backgroundColor: purple[700],
  },
}));

export default function Main(props) {
  const {posts, title} = props;

  return (
    <Grid item xs={12} md={8}>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Divider />
      {/* Visualize the post content */}
      {/* <pre>Blog content :: {JSON.stringify(posts, null, 2)}</pre> */}
      {posts.map((post) => (
        <>
          <Markdown style={sxStyles.markdown} key={post.substring(0, 40)}>
            {post}
          </Markdown>
          {/* <Markdown>{post}</Markdown>; */}
        </>
      ))}
      {/* <Markdown># Hello world!</Markdown>; */}
      <ColorButton
        variant="contained"
        color="primary"
        onClick={routeToContactUs}
        style={{display: props.discoverMore}}
      >
        Discover More
      </ColorButton>
    </Grid>
  );
}

Main.propTypes = {
  posts: PropTypes.array,
  title: PropTypes.string,
};
